/**
 * BprDiagramLegend - the one legend for every BPR diagram surface (module
 * diagrams tab, deal-embedded System Architecture, per-section process-flow
 * embeds), so the node-status and edge-kind vocabulary reads identically
 * everywhere. Node statuses: existing solid / new highlighted / changed
 * dashed / removed muted. Edge kinds: integration solid, manual handoff
 * dashed (warning), data flow dotted.
 */

export interface BprDiagramLegendProps {
  /** Optional right-aligned hint (e.g. "click a node to see its linked issues"). */
  hint?: string;
}

export function BprDiagramLegend({ hint }: BprDiagramLegendProps) {
  return (
    <div className="bpr-diagrams__legend" aria-label="Diagram legend">
      <span className="bpr-diagrams__legend-item bpr-diagrams__legend-item--existing">
        existing
      </span>
      <span className="bpr-diagrams__legend-item bpr-diagrams__legend-item--new">new</span>
      <span className="bpr-diagrams__legend-item bpr-diagrams__legend-item--changed">changed</span>
      <span className="bpr-diagrams__legend-item bpr-diagrams__legend-item--removed">removed</span>
      <span className="bpr-diagrams__legend-line bpr-diagrams__legend-line--integration">
        integration
      </span>
      <span className="bpr-diagrams__legend-line bpr-diagrams__legend-line--manual">
        manual handoff
      </span>
      <span className="bpr-diagrams__legend-line bpr-diagrams__legend-line--data-flow">
        data flow
      </span>
      {hint ? <span className="bpr-diagrams__legend-hint">{hint}</span> : null}
    </div>
  );
}
